import _ from 'lodash';
import Pluralize from 'pluralize';
import { isTrue } from '../utils';

let initSettings = {
	fetching_main_settings: false,
	fetching_general: false,
	fetching_contact: false,
	fetching_invoices: false,
	fetching_members: false,
	fetching_membership_types: false,
	fetching_subscriptions: false,
	fetching_enrolments: false,
	fetching_courses: false,
	fetching_tutors: false,
	fetching_labels_courses: false,
	fetching_labels_members: false,
	request_main_settings: {fetching: false, expires: 0},
	request_courses_info: {fetching: false, expires: 0},
	request_members_info: {fetching: false, expires: 0},
	general: {
		expires: 0,
		data: {
			display_name: "U3A Name",
			formal_name: "U3A Name",
			website: "",
			website_link_text: "U3A Name",
			courses_link_text: "Courses and activities available at our U3A",
			umas_version: "0",
			umas_date: "1970-01-01",
			umas_status: 0,
			joining_on: false,
			enrolling_on: false,
			general_enrol_on: false,
			early_enrol_on: false,
			absences_on: false,
			buy_membership_on: false,
			special_interests_on: false,
			max_active_minutes: 0,
			state: "",
			vaccine_rules_on: false
		}
	},
	contact: {
		expires: 0,
		data: {
			display_name: "U3A Name",
			formal_name: "U3A Name",
			website: "",
			address: "",
			postal_address: "",
			general_email: "",
			courses_email: "",
			sys_admin_email: "",
			volunteer_email: "",
			phone: "",
			office_hours: ""
		}
	},
	invoices: {
		expires: 0,
		data: {
			paypal: {
				accept: false,
				sandbox: true,
				email: ""
			},
			bank: {
				accept: false,
				use_payid: false,
				detail: "",
				payid_detail: ""
			},
			accept_cash_at_office: false, 
			accept_cheques_at_office: false, 
			accept_eftpos_at_office: false,
			accept_cheques_via_post: false,
			default_hide_paid_invoices: false,
			formal_name: "",
			make_cheques_out_to: "",
			incorporation: "",
			abn: "",
			address: "",
			postal_address: "",
			show_zero_value_invoices: false,
			use_tax_invoices: false
		}
	},
	members: {
		expires: 0,
		data: {
			default_membership_type: "",
			use_member_type_fee: true,
			allow_member_type_change: false,
			allow_badge_printing: false,
			minimum_joining_age: 0,
			show_terms_and_conditions: true,
			terms_and_conditions_note: "",
			terms_and_conditions_url: "",
			show_preferred_name: false,
			show_address1: false,
			show_country: false,
			default_state: '',
			show_phone_business: false,
			show_checkbox1: false,
			show_checkbox2: false,
			show_checkbox3: false,
			show_checkbox4: false,
			show_notes: false,
			show_employer: false,
			show_fax: false,
			show_occupation: false,
			require_occuption: false,
			show_registration: false,
			require_registration: false,
			show_registration_date: false,
			require_registration_date: false,
			show_classification: false,
			show_classifier1: false,
			show_classifier2: false,
			show_classifier3: false,
			show_spare_field: false,
			show_received_date: false,
			show_tickets: false,
			show_number1: false,
			show_number2: false,
			show_emergency_relationship: false,
			require_emergency_relationship: false,
			vaccine_rules_on: false,
			vax_message_join: '',
			vax_message_member: '',
			general_message_join: '',
			general_message_member: '',
		}
	},
	membership_types: {
		expires: 0,
		data: [] 
	},
	subscriptions: {
		expires: 0,
		data: [] 
	},
	classifier_classification: {
		expires: 0,
		data: [] 
	},
	classifier_classifier1: {
		expires: 0,
		data: [] 
	},
	classifier_classifier2: {
		expires: 0,
		data: [] 
	},
	classifier_classifier3: {
		expires: 0,
		data: [] 
	},
	enrolments: {
		expires: 0,
		data: {
			enrolments_on: false,
			general_enrol_on: false,
			early_enrol_on: false,
			early_enrol_start_date: "",
			enrolment_limits_on: false,
			max_enrolments_allowed: 0,
			max_enrolments_end_date: "",
			member_courses_start_date: "",
			member_courses_end_date: "",
			vaccine_rules_on: false
		}
	},
	courses: {
		expires: 0,
		data: {
			hide_code_in_list: false,
			hide_frequency_in_list: false,
			hide_finished_in_list: false,
			hide_tutor_in_list: false,
			hide_tutor_from_public: true,
			member_courses_start_date: "",
			member_courses_end_date: "",
			api_courses_start_date: "",
			api_courses_end_date: "",
			default_list_timespan: "Current timetable",
			default_list_sort_first: "category_code",
			default_list_sort_second: "day",
			default_show_closed_courses: false,
			show_additional_detail: false
		}
	},
	terms: {
		expires: 0,
		data: {} 
	},
	venues: {
		expires: 0,
		data: {} 
	},
	course_categories: {
		expires: 0,
		data: {} 
	},
	course_frequencies: {
		expires: 0,
		data: {} 
	},
	course_types: {
		expires: 0,
		data: {} 
	},
	tutors: {
		expires: 0,
		data: {} 
	},
	labels_courses: {
		expires: 0,
		data: {
			course: "Course",
			tutor: "Tutor",
			tutor2: "",
			venue: "Venue",
			frequency: "Frequency",
			fee1: "Full fee",
			category: "Category",
			courseLabel: 'course',
			courseCapLabel: 'Course',
			coursesLabel: 'courses',
			coursesCapLabel: 'Courses',
		}
	},
	labels_members: {
		expires: 0,
		data: {
			volunteers: "Volunteers",
			surname: "Surname",
			employer: "",
			address1: "",
			street: "Street",
			suburb: "Suburb",
			state: "State",
			postcode: "Postcode",
			phone_home: "Phone home",
			phone_business: "",
			mobile: "Mobile phone",
			occupation: "",
			fax: "",
			member_type: "Member type",
			classification: "",
			registration: "",
			registration_date: "",
			classifier1: "",
			classifier2: "",
			classifier3: "",
			spare_field: "",
			received_date: "",
			tickets: "",
			number1: "",
			number2: "",
			checkbox1: "",
			checkbox2: "",
			checkbox3: "",
			checkbox4: "",
			emergency_contact: "Emergency contact name",
			emergency_number: "Emergency contact number",
			emergency_relationship: "",
			fully_vaccinated: "fully vaccinated"
		}
	},
	routes: {
		home: {
			hidden: false,
			status: 0,
		},
		courses: {
			hidden: false,
			status: 1,
		},
		course: {
			hidden: true,
			status: 1,
		},
		member: {
			hidden: false,
			status: 1,
		},
		member_enrolments: {
			hidden: false,
			status: 1,
		},
		member_invoices: {
			hidden: false,
			status: 1,
		},
		buy_membership: {
			status: 1,
		},
		member_absences: {
			hidden: false,
			status: 1,
		},
		cart: {
			hidden: false,
			status: 1,
		},
		checkout: {
			hidden: false,
			status: 1,
		},
		login: {
			hidden: false,
			status: 1,
		},
		login_as: {
			hidden: true,
			status: 1,
		},
		login_reset_password: {
			hidden: true,
			status: 1,
		},
		login_retrieve_member_no: {
			hidden: true,
			status: 1,
		},
		login_retrieve_member_details: {
			hidden: true,
			status: 1,
		},
		logout: {
			hidden: false,
			status: 0
		},
		join: {
			hidden: false,
			status: 1,
		},
		contact: {
			hidden: false,
			status: 0,
		},
		reset_password: {
			hidden: true,
			status: 1,
		},
	},
	links: ['home', 'contact']

};

const settings = (state = initSettings, action) => {
	const exp = Math.floor(Date.now() / 1000) + 3600; // current time + 1 hr
	switch (action.type) {
		case 'MAIN_SETTINGS_REQUEST':
			return {...state, fetching_main_settings: true}
		case 'MAIN_SETTINGS_FAILURE':
			return {...state, fetching_main_settings: false}
		case 'MAIN_SETTINGS_SUCCESS':
			let filterRoutes, filterLinks;
			switch(action.response.settings.general.umas_status){
				case 0:
					filterRoutes = _.pick(initSettings.routes, ['home', 'contact']);
					filterLinks = ['home', 'contact'];
					break;
				case 1: 
					if(action.response.settings.general.enrolling_on && action.response.settings.general.early_enrol_on){
						filterRoutes = _.cloneDeep(initSettings.routes);
						if(!(action.response.settings.general.absences_on)){
							delete filterRoutes.member_absences;
						}
						if(!(action.response.settings.general.buy_membership_on)){
							delete filterRoutes.buy_membership;
						}

						filterLinks = _.chain(filterRoutes).pickBy((r, i) => {
							return !(r.hidden);
						}).keys().value();
						
						if(!(action.response.settings.general.joining_on)){
							_.pull(filterLinks, 'join');
						}
					} else {
						filterRoutes = _.pick(initSettings.routes, 
							['home', 'courses', 'course', 'contact', 'join', 'login', 'login_as', 'logout', 'login_reset_password',
							'login_retrieve_member_no', 'login_retrieve_member_details', 'reset_password']);
						filterLinks = ['home', 'courses', 'contact', 'logout'];
					}
					break;
				default:
					filterRoutes = _.cloneDeep(initSettings.routes);
					if(!(action.response.settings.general.absences_on)){
						delete filterRoutes.member_absences;
					}
					if(!(action.response.settings.general.buy_membership_on)){
						delete filterRoutes.buy_membership;
					}
					if(!(action.response.settings.general.enrolling_on) && !(action.response.settings.general.buy_membership_on)){
						delete filterRoutes.cart;
						delete filterRoutes.checkout;
					}
					filterLinks = _.chain(filterRoutes).pickBy((r) => {
						return (!(r.hidden));
					}).keys().value();
					if(!action.response.settings.general.joining_on){
						_.pull(filterLinks, 'join');
					}
			};
			const course_labels = {...action.response.labels.courses, 
				courseLabel: _.toLower(Pluralize.singular(action.response.labels.courses.course)),
				courseCapLabel: _.capitalize(Pluralize.singular(action.response.labels.courses.course)),
				coursesLabel: _.toLower(Pluralize(action.response.labels.courses.course)),
				coursesCapLabel: _.capitalize(Pluralize(action.response.labels.courses.course)),
			};
			
			const member_labels = {...action.response.labels.members,
				fully_vaccinated: (action.response.labels.members.fully_vaccinated ? _.toLower(action.response.labels.members.fully_vaccinated): 'fully vaccinated')
			};
			
			let i = {...action.response.settings.invoices};
			i.make_cheques_out_to = i.make_cheques_out_to || i.formal_name;
			
			let g = {...action.response.settings.general};
			g.website_link_text = g.website_link_text || g.display_name;
			g.courses_link_text = g.courses_link_text || 'Courses and activities available at our U3A';
			
			return {...state, 
				general: {expires: exp, data: g}, 
				routes: filterRoutes, 
				links: filterLinks,
				invoices: {expires: exp, data: i},
				courses: {expires: exp, data: action.response.settings.courses},
				enrolments: {expires: exp, data: action.response.settings.enrolments},
				members: {expires: exp, data: action.response.settings.members},
				labels_members: {expires: exp, data: member_labels},
				labels_courses: {expires: exp, data: course_labels}
			}	
		case 'GENERAL_SETTINGS_SUCCESS':
			let filteredRoutes, filteredLinks;
			switch(action.response.umas_status){
				case 0:
					filteredRoutes = _.pick(initSettings.routes, ['home', 'contact']);
					filteredLinks = ['home', 'contact'];
					break;
				case 1: 
					if(action.response.enrolling_on && action.response.early_enrol_on){
						filteredRoutes = _.cloneDeep(initSettings.routes);
						if(!(action.response.absences_on)){
							delete filteredRoutes.member_absences;
						}
						if(!(action.response.buy_membership_on)){
							delete filteredRoutes.buy_membership;
						}

						filteredLinks = _.chain(filteredRoutes).pickBy((r, i) => {
							return !(r.hidden);
						}).keys().value();
						
						if(!(action.response.joining_on)){
							_.pull(filteredLinks, 'join');
						}
					} else {
						filteredRoutes = _.pick(initSettings.routes, 
							['home', 'courses', 'course', 'contact', 'join', 'login', 'login_as', 'logout', 'login_reset_password',
							'login_retrieve_member_no', 'login_retrieve_member_details', 'reset_password']);
						filteredLinks = ['home', 'courses', 'contact', 'logout'];
					}
					break;
				default:
					filteredRoutes = _.cloneDeep(initSettings.routes);
					if(!(action.response.absences_on)){
						delete filteredRoutes.member_absences;
					}
					if(!(action.response.buy_membership_on)){
						delete filteredRoutes.buy_membership;
					}
					if(!(action.response.enrolling_on) && !(action.response.buy_membership_on)){
						delete filteredRoutes.cart;
						delete filteredRoutes.checkout;
					}
					filteredLinks = _.chain(filteredRoutes).pickBy((r) => {
						return (!(r.hidden));
					}).keys().value();
					if(!action.response.joining_on){
						_.pull(filteredLinks, 'join');
					}
			}
			
			let gS = {...action.response.settings.general};
			gS.website_link_text = gS.website_link_text || gS.display_name;
			gS.courses_link_text = gS.courses_link_text || 'Courses and activities available at our U3A';
			
			return {...state, general: {expires: exp, data: gS}, routes: filteredRoutes, links: filteredLinks }
		case 'CONTACT_SETTINGS_REQUEST':
			return {...state, fetching_contact: true}
		case 'CONTACT_SETTINGS_FAILURE':
			return {...state, fetching_contact: false}
		case 'CONTACT_SETTINGS_SUCCESS':
			return {...state, contact: {expires: exp, data: action.response}, fetching_contact: false }
		case 'INVOICES_SETTINGS_SUCCESS':
			let iS = {...action.response};
			iS.make_cheques_out_to = iS.make_cheques_out_to || iS.formal_name;
		
			return {...state, invoices: {expires: exp, data: iS} }
		case 'MEMBERS_INFO_REQUEST':
			const me = state.request_members_info.expires;
			return {...state, request_members_info: {fetching: true, expires: me}}
		case 'MEMBERS_INFO_FAILURE':
			return {...state, request_members_info: {fetching: false, expires: 0}}
		case 'MEMBERS_INFO_SUCCESS':
			return {...state,
				membership_types: {expires: exp, data: action.response.membership_types},
				classifier_classification: {expires: exp, data: action.response.classification},
				classifier_classifier1: {expires: exp, data: action.response.classifier1},
				classifier_classifier2: {expires: exp, data: action.response.classifier2},
				classifier_classifier3: {expires: exp, data: action.response.classifier3}
			}
		case 'MEMBERS_SETTINGS_SUCCESS':
			return {...state, members: {expires: exp, data: action.response} }
		case 'MEMBERSHIP_TYPES_SUCCESS':
			return {...state, membership_types: {expires: exp, data: action.response} }
		case 'SUBSCRIPTIONS_REQUEST':
			return {...state, fetching_subscriptions: true }
		case 'SUBSCRIPTIONS_SUCCESS':
			return {...state, subscriptions: {expires: exp, data: action.response}, fetching_subscriptions: false }
		case 'SUBSCRIPTIONS_FAILURE':
			return {...state, fetching_subscriptions: false }
		case 'ENROLMENTS_SETTINGS_SUCCESS':
			return {...state, enrolments: {expires: exp, data: action.response} }
		case 'COURSES_SETTINGS_SUCCESS':
			return {...state, courses: {expires: exp, data: action.response} }
		case 'COURSES_INFO_REQUEST':
			const ce = state.request_courses_info.expires;
			return {...state, request_courses_info: {fetching: true, expires: ce}}
		case 'COURSES_INFO_FAILURE':
			return {...state, request_courses_info: {fetching: false, expires: 0}}
		case 'COURSES_INFO_SUCCESS':
			const d = _.chain(action.response.categories).keyBy('code').mapValues(v => {
				return {...v, 
					max_enrol: _.toInteger(v.max_enrol), 
					exempt_from_global_max_enrol: isTrue(v.exempt_from_global_max_enrol)
				}
			}).value();
			
			return {...state,
				terms: {expires: exp, data: _.keyBy(action.response.terms, 'term_name')},
				course_categories: {expires: exp, data: d},
				course_types: {expires: exp, data: _.keyBy(action.response.types, 'code')},
				course_frequencies: {expires: exp, data: _.keyBy(action.response.frequencies, 'code')},
				venues: {expires: exp, data: _.keyBy(action.response.venues, 'code')}
			}
		case 'TUTORS_SUCCESS':
			return {...state, tutors: {expires: exp, data: _.keyBy(action.response, 'code')} }
		case 'LABELS_COURSES_SUCCESS':
			const labels = {...action.response, 
				courseLabel: _.toLower(Pluralize.singular(action.response.course)),
				courseCapLabel: _.capitalize(Pluralize.singular(action.response.course)),
				coursesLabel: _.toLower(Pluralize(action.response.course)),
				coursesCapLabel: _.capitalize(Pluralize(action.response.course)),
			};
			
			return {...state, labels_courses: {expires: exp, data: labels}}
		case 'LABELS_MEMBERS_SUCCESS':
			const ml = {...action.response,
				fully_vaccinated: (action.response.fully_vaccinated ? _.toLower(action.response.fully_vaccinated): 'fully vaccinated')
			};
		
			return {...state, labels_members: {expires: exp, data: ml} }
		case 'LOGIN_SUCCESS':
		case 'LOGOUT_SUCCESS':
		case 'USER_FAILURE':
			return {...state, tutors: {expires: 0, data: {}}}
		default:
			return state;
	}

}

export default settings 
